/*******************************************************************************
 * Copyright     : Copyright (c)  2021 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          : Routes.tsx
 *
 * Project Title : APM Settings Tool
 *
 * Description   : Routes component
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : H422335
 *
 * @Date         : December 16, 2021
 *
 * @Version      : Version 1.0
 *
 * By            : H422335
 * On            : December 23, 2021
 * Description   : Added Routes component to define all routes of the application
 *
 *******************************************************************************/

import React, { FC, useEffect } from "react";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Authorize, useAuth } from "components/Auth";
import { ErrorBoundary } from "./components/ErrorBoundary";

import Header from "components/Header";
import Footer from "components/Footer";
import CommonHeader from "components/CommonHeader";
import Home from "pages/Home";
import CreateNewApm from "pages/CreateNewApm";
import { appConfig } from "shared/utils";
import NotFoundPage from "pages/NotFound/NotFound";
import PreviewApmSettings from "pages/PreviewApmSettings";

const Logout: FC = () => {
  useEffect(() => {
    window.location.href = appConfig.asds_endpoint;
  }, []);

  return <h1>Logging Out..</h1>;
};

export const PageRoutes: FC = () => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  let routes;

  if (isAuthenticated) {
    routes = (
      <React.Fragment>
        <Header />
        <CommonHeader>
          <ErrorBoundary key={location.pathname}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="new" element={<CreateNewApm />} />
              <Route path="preview" element={<PreviewApmSettings />} />
              <Route path="authorize" element={<Navigate replace to="/" />} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </ErrorBoundary>
        </CommonHeader>
        <Footer />
      </React.Fragment>
    );
  } else {
    routes = (
      <Routes>
        <Route path="/logout" element={<Logout />} />
        <Route path="/authorize" element={<Authorize />} />
        <Route path="*" element={<Navigate replace to="/authorize" />} />
      </Routes>
    );
  }

  return <main>{routes}</main>;
};
